import { STATUS_META } from "../../lib/constants";
import type { Status } from "../../lib/api";
import { cn } from "../../lib/cn";

export function StatusBadge({
  status,
  className,
}: {
  status: Status;
  className?: string;
}) {
  const meta = STATUS_META[status];
  if (!meta) return null;
  return (
    <span className={cn("badge", meta.text, meta.bg, meta.border, className)}>
      {meta.label}
    </span>
  );
}
